/**
 * Store state for wordpress/posts module
 */
export const initialState = {
  posts: [
    // {
    //   ...post,
    //   components: '',
    //   header: '',
    //   css: '',
    //   extensions: ''
    // }
  ],
  selected: null
}

const state = {...initialState}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/posts/state.js